"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const _projectList = require("../../modules/project/list/reducers");
const _folderTree = require("../../modules/files/tree/reducers");
const _usergroupList = require("../../modules/usergroup/list/reducers");
const archive = require("./archive");
const list = require("./list");
const metas = require("./metas");
const schema = require("./schema");
const wizard = require("./wizard");
const projectListReducer = _projectList.default('subproject');
const folderTreeReducer = _folderTree.default('subproject', 'INHERIT_SELECTION');
const usergroupListReducer = _usergroupList.default('subproject');
//#endregion
//#region INITIAL STATE
exports.initialState = {
    archive: Object.assign({}, archive.initialState),
    list: Object.assign({}, list.initialState),
    metas: Object.assign({}, metas.initialState),
    projects: Object.assign({}, projectListReducer.initialState),
    folderTree: Object.assign({}, folderTreeReducer.initialState),
    usergroups: Object.assign({}, usergroupListReducer.initialState),
    schema: Object.assign({}, schema.initialState),
    wizard: Object.assign({}, wizard.initialState)
};
//#endregion
//#region LENS
const archiveLens = monocle.Lens.fromProp('archive');
const listLens = monocle.Lens.fromProp('list');
const metasLens = monocle.Lens.fromProp('metas');
const projectsLens = monocle.Lens.fromProp('projects');
const folderTreeLens = monocle.Lens.fromProp('folderTree');
const usergroupsLens = monocle.Lens.fromProp('usergroups');
const schemaLens = monocle.Lens.fromProp('schema');
const wizardLens = monocle.Lens.fromProp('wizard');
//#endregion
//#region REDUCER
const handleArchive = (action) => (state) => {
    const fn = archive.methods[action.type];
    if (fn) {
        return archiveLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleList = (action) => (state) => {
    const fn = list.methods[action.type];
    if (fn) {
        return listLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleMetas = (action) => (state) => {
    const fn = metas.methods[action.type];
    if (fn) {
        return metasLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleProjects = (action) => (state) => {
    const fn = projectListReducer.methods[action.type];
    if (fn) {
        return projectsLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleFolderTree = (action) => (state) => {
    const fn = folderTreeReducer.methods[action.type];
    if (fn) {
        return folderTreeLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleUsergroups = (action) => (state) => {
    const fn = usergroupListReducer.methods[action.type];
    if (fn) {
        return usergroupsLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleSchema = (action) => (state) => {
    const fn = schema.methods[action.type];
    if (fn) {
        return schemaLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleWizard = (action) => (state) => {
    const fn = wizard.methods[action.type];
    if (fn) {
        return wizardLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
// Reducer
exports.default = (state = exports.initialState, action) => {
    return fp.function.compose(handleArchive(action), handleList(action), handleMetas(action), handleProjects(action), handleFolderTree(action), handleUsergroups(action), handleSchema(action), handleWizard(action))(state);
};
//#endregion
//# sourceMappingURL=index.js.map